var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('company-select-modal',{attrs:{"titleKey":"admin.user.action.updateCompany","confirm-company":_vm.confirm}})}
var staticRenderFns = []

export { render, staticRenderFns }